import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { CHINA_MAP_SHEET_BUTTONS_GAP, CHINA_MAP_SHEET_HEIGHTS } from "#china-map-sheet-heights";

/**
 * How far below its resting place the map's sheet starts when the map opens (and ends when it
 * closes): far enough for the tallest resting sheet and the two buttons stacked above it to clear
 * the bottom edge. A sheet dragged higher is covered by the returning cards before it is gone.
 */
export function useChinaMapSheetSlideDistance(): number {
  const { diameter } = useToolbarGridMetrics();
  const tallestRestingSheet = Math.max(...Object.values(CHINA_MAP_SHEET_HEIGHTS));
  return tallestRestingSheet + 2 * diameter + 3 * CHINA_MAP_SHEET_BUTTONS_GAP;
}
